import { createElement } from 'react';
import { createRoot } from 'react-dom/client';
import { createLogger, loggerStyles } from '@ricoh/ria.client.core/plugins/app/logger';

import type { AppProps } from './_.type';

import ApplicationRoot from './_.view';

const logger = createLogger('app');

/**
 * Render Application.
 *
 * @param {AppProps} appProps Application props.
 */
function render(appProps: AppProps) {
  const rootEl = document.querySelector('main');
  if (!rootEl) {
    logger.write('error', `${loggerStyles.errorText('Error')} app root not found`);

    return;
  }

  const root = createRoot(rootEl);
  root.render(createElement(ApplicationRoot, appProps));

  logger.write('info', `${loggerStyles.responseText('Init')} app`);
}

/** Application. */
const app = {
  render,
};

export default app;
